// Browser-side copy of the Hello! tile's last Greetings answer (see useGreetingsSummary). Kept in its
// own file with no imports so sign-out can clear it without pulling the hook's dependencies in.
export const GREETINGS_SUMMARY_CACHE_PREFIX = 'neighbors.greetingsSummary.';

// Removes every resident's entry, so nothing about one person's Greetings stays on a shared browser.
export const clearAllGreetingsSummaryCache = () => {
    try {
        const keys: string[] = [];
        for (let i = 0; i < window.localStorage.length; i += 1) {
            const key = window.localStorage.key(i);
            if (key && key.startsWith(GREETINGS_SUMMARY_CACHE_PREFIX)) keys.push(key);
        }
        keys.forEach((key) => window.localStorage.removeItem(key));
    } catch (_error) {
        // Storage blocked or unavailable: there is nothing saved to clear.
    }
};
